import { BLANK_REGEX } from '#constants/regex';

export const alphabeticCompare = (aString, otherString) => aString.localeCompare(otherString) === 0;

export const capitalizeFirstLetter = string =>
  string?.[0].toUpperCase().concat(string.slice(1).toLowerCase());

export const validateStringWithRegex = (string, regex) => !string || !!string.match(regex);

export const getLastChar = str => str[str.length - 1];

export const takeNCharacters = amount => str => str.slice(0, amount);

export const dropNCharacters = amount => str => str.slice(amount, str.length);

export const isBlank = str => BLANK_REGEX.test(str);
